module.exports = __webpack_public_path__ + "img/Service Module.de498b04.jpeg";